// extracted by mini-css-extract-plugin
export default {"BackButton":"backButton_BackButton__wg4zC","path":"backButton_path__nIQp-"};